<template>
  <AppSelect
    :label="$tt('occupation')"
    :items="toSelectItems(statuses)"
    :placeholder="$tt('select_occupation')"
  />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { OccupationStatus } from '~/types';

const { tt } = useLocalization();

const statuses: Record<OccupationStatus, string> = {
  employee: tt('employee'),
  self_employed: tt('self_employed'),
  retired: tt('retired'),
  unemployed: tt('unemployed'),
  student: tt('student'),
  underage: tt('underage')
};
</script>